import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response";

export const useDeleteStanding = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { sport, organizationId, seasonId } = useParams();
  const notification = useNotification();
  const { formatMessage } = useIntl();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (standingId: string) => {
      return await request(`${sport}/o/${organizationId}/standings/${standingId}`, { method: "DELETE" });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success) {
        await queryClient.invalidateQueries({
          queryKey: ["standings", sport, organizationId, seasonId],
          exact: false,
        });
        notification.success({
          message: formatMessage({ id: "success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
